import { useQuery } from '@tanstack/react-query';
import { getChargeCatalog } from '../services/chargeCatalogService';

/**
 * Chargeable items (active-menu items + services) for the Add-charge modal.
 * `forStaff` filters services to staff-purchasable ones and prices them at the
 * staff rate. Lazy — only fetched while the dialog is open.
 */
export function useChargeCatalog(
  locationId: string | undefined,
  forStaff: boolean,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: ['charge-catalog', locationId, forStaff],
    queryFn: () => getChargeCatalog(locationId!, forStaff),
    enabled: !!locationId && (options?.enabled ?? true),
    staleTime: 60_000,
  });
}
